module.exports = __webpack_public_path__ + "static/media/mbr-2-1920x1280.f291c969.jpg";